module.exports = __webpack_public_path__ + "static/img/unit7.6a590cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit7.png
// module id = qq4h
// module chunks = 1